export default {
  // list
  'base_cargo_spec.query.cargoTypeId': 'cargoTypeId',
  'base_cargo_spec.query.cargoTypeId.placeholder': 'Enter cargoTypeId',
  'base_cargo_spec.query.specName': 'specName',
  'base_cargo_spec.query.specName.placeholder': 'Enter specName',
  'base_cargo_spec.column.cargoTypeId': 'cargoTypeId',
  'base_cargo_spec.column.specName': 'specName',
  'base_cargo_spec.column.createBy': 'createBy',
  'base_cargo_spec.column.updateBy': 'updateBy',
  'base_cargo_spec.column.createTime': 'createTime',
  'base_cargo_spec.column.updateTime': 'updateTime',
  'base_cargo_spec.column.dataSource': 'dataSource',
  'base_cargo_spec.column.remark': 'remark',
  'base_cargo_spec.column.status': 'status',
  // edit
  'base_cargo_spec.edit.title': 'Edit BaseCargoSpec',
  'base_cargo_spec.add.title': 'Add BaseCargoSpec',
  'base_cargo_spec.edit.success': 'Edit Successful',
  'base_cargo_spec.add.success': 'Add Successful',
  'base_cargo_spec.form.cargoTypeId.required': 'cargoTypeId cannot be null',
  'base_cargo_spec.form.specName.required': 'specName cannot be null',
  'base_cargo_spec.form.cargoTypeId': 'cargoTypeId',
  'base_cargo_spec.form.cargoTypeId.placeholder': 'Enter cargoTypeId',
  'base_cargo_spec.form.specName': 'specName',
  'base_cargo_spec.form.specName.placeholder': 'Enter specName',
}
